export const SITE_SUCCESS = 'GET_SITES';
export const GET_SITES = 'GET_SITES';
export const GET_SITE_DETAILS = 'GET_SITE_DETAILS';
export const GET_SITE_PAYMENTS = 'GET_SITE_PAYMENTS';
export const SELECTED_SITE_ID = 'SELECTED_SITE_ID';
export const GET_SITE_DOCUMENTS = 'GET_SITE_DOCUMENTS';
export const GET_SITE_PROGRESS = 'GET_SITE_PROGRESS';
export const GET_SITE_PROGRESS_IMAGE = 'GET_SITE_PROGRESS_IMAGE';
export const SELECTED_PROJECT_ID = 'SELECTED_PROJECT_ID';